require('dragscroll');
import { Loader } from '@googlemaps/js-api-loader';
let { __, _x, sprintf } = wp.i18n;

class TELocationMapWidget extends elementorModules.frontend.handlers.Base {
    onInit() {
        let $element = this.$element;
        let element = $element[0];
        let settings = JSON.parse( element.querySelector('[data-settings]').textContent );
        let {type, zoom, zoomControl, scrollWheel} = settings;
        let markerSize = settings.marker;

        let mapId = (settings.mapId !== '') ? settings.mapId : this.generateRandomString(16);

        let mapContainerEl = element.querySelector('.map');
        let mapEl = element.querySelector('.map__pane');

        let mapLocationEl = document.createElement('div');
        mapLocationEl.classList.add('map__location');

        let mapLocationInnerEl = document.createElement('div');
        mapLocationInnerEl.classList.add('map__location-inner');
        
        let mapInfoPanelEl = element.querySelector('.map__info-panel');
        mapContainerEl.classList.add('map--' + type);
        mapInfoPanelEl.setAttribute('data-panel-info', '');
        mapInfoPanelEl.innerHTML = `<div class="map__info-panel-inner"></div>`;
        const infoScrollBar = new SimpleBar( mapInfoPanelEl );

        let userControlEl;

        let listEl = document.createElement('ul');
        listEl.classList.add('map__location-list');

        let groupEl = document.createElement('div');
        ['map__group', 'dragscroll'].forEach( c => groupEl.classList.add(c) );

        /* Disable drag event for map dragging */
        element.addEventListener('dragstart', (ev) => ev.preventDefault());
        element.addEventListener('dragend', (ev) => ev.preventDefault());
        element.addEventListener('dragstop', (ev) => ev.preventDefault());

        const isSmall = () => mapContainerEl.clientWidth <= 600;

        if ( !mapEl ) {
            return;
        }

        let GLOBAL = window.LocationMap;

        const loader = new Loader({
            apiKey: GLOBAL.api_key,
            version: 'weekly',
        });

        loader.load().then( async () => {
            const { Map } = await google.maps.importLibrary('maps');
            const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

            let mapOptions = {
                mapId: mapId,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoom: zoom,
                zoomControl: zoomControl === '1',
            }

            if (scrollWheel === '1') {
                mapOptions.scrollwheel = true;
            }

            let map = new Map(mapEl, mapOptions);
            let markers = [];
            let bounds = new google.maps.LatLngBounds();

            if ( type === 'single' ) {
                let { items } = settings;
                let { title, latlng, marker_icon, id } = items[0];
                let { lat, lng } = getLatLngFromString(latlng);
                let iconHTML = getIconHTML(marker_icon, id);
                let markerElement = getMarkerHTMLElement(iconHTML, id);
                let marker = createMarker( lat, lng, title, markerElement );

                markers.push(marker);
                bounds.extend({lat, lng});

                marker.addListener('click', ev => {
                    if (!mapInfoIsShow()) {
                        mapInfoShow();
                    }

                    map.getZoom() < 15 && map.setZoom(15);

                    map.panTo({lat, lng});

                    let offsetX = 0, offsetY = 0;

                    offsetY -= markerSize.height / 2;
                    
                    if (!isSmall()) {
                        if (mapInfoIsShow()) {
                            offsetX += (mapInfoPanelEl.clientWidth + 16) / 2;
                        }
                    } else {
                        offsetY += 184/2;
                    }

                    map.panBy(offsetX, offsetY);

                    mapInfoUpdate(id);
                } );
            } else if ( type === 'multiple' ) {
                let { items } = settings;
                mapContainerEl.appendChild(mapLocationEl);

                items.forEach( item => {
                    let { title, latlng, marker_icon, id } = item;
                    let { lat, lng } = getLatLngFromString(latlng);
                    let iconHTML = getIconHTML(marker_icon);
                    let markerElement = getMarkerHTMLElement(iconHTML, id);
                    let marker = createMarker( lat, lng, title, markerElement, id );

                    markers.push(marker);
                    bounds.extend({lat, lng});

                    let listItem = document.createElement('li');
                    listItem.classList.add('map__location-list__item');
                    listItem.dataset.id = id;
                    listItem.setAttribute('data-location', '');
                    listItem.innerHTML = `<div class="label">${title}</div>`;
                    listEl.appendChild(listItem);

                    marker.addListener('click', ev => {
                        if (!mapInfoIsShow()) {
                            mapInfoShow();
                        }

                        if (map.getZoom() < 15) {
                            map.setZoom(15);
                        }
                        
                        map.panTo({lat, lng});

                        let
                        offsetX = 0,
                        offsetY = 0;

                        offsetY -= markerSize.height / 2;

                        if ( isSmall() ) {
                            offsetY += 184/2;
                        }

                        map.panBy(offsetX, offsetY);
                        mapInfoUpdate( id );
                    });
                } );

                mapLocationInnerEl.appendChild(listEl);
                mapLocationEl.appendChild(mapLocationInnerEl);
            } else if ( type === 'multiple_cat' ) {
                let { items } = settings;
                let locationListByCat = [];
                let categories = items.map( item => item.category );
                let uniqueCategories = [...new Set(categories)];
                mapContainerEl.appendChild(mapLocationEl);

                uniqueCategories.forEach( category => {
                    locationListByCat.push( {
                        title: category.charAt(0).toUpperCase() + category.slice(1),
                        slug: category.toLowerCase(),
                        items: []
                    } );
                } );

                items.forEach( item => {
                    let { title, latlng, marker_icon, id, category } = item;
                    let { lat, lng } = getLatLngFromString(latlng);
                    let iconHTML = getIconHTML(marker_icon, id);
                    let markerElement = getMarkerHTMLElement(iconHTML, id);
                    let marker = createMarker( lat, lng, title, markerElement, id );

                    markers.push(marker);
                    bounds.extend({lat, lng});

                    marker.addListener('click', ev => {
                        if ( isSmall() ) {
                            userControlEl.API.hide();
                        }

                        if (!mapInfoIsShow()) {
                            mapInfoShow();
                        }

                        if (map.getZoom() < 15) {
                            map.setZoom(15);
                        }

                        map.panTo({lat, lng});

                        let
                        offsetX = 0,
                        offsetY = 0;

                        offsetY -= markerSize.height / 2;

                        if ( isSmall() ) {
                            offsetY += 184/2;
                        }

                        map.panBy(offsetX, offsetY);

                        mapInfoUpdate( id );
                    });

                    locationListByCat.find( cat => cat.slug === category.toLowerCase() ).items.push( item );
                } );

                let groupListEl = document.createElement('ul');
                groupListEl.classList.add('map__group__list');

                /* Generate `All` filter item */
                let allCategoryItem = document.createElement('li');
                allCategoryItem.classList.add('map__group__list-item');
                allCategoryItem.innerHTML = `<span data-group="all" class="group-toggle active">${ _x('All', 'location-map', 'travelanium-elementor') }</span>`;
                groupListEl.appendChild(allCategoryItem);

                /* Generate list item */
                locationListByCat.forEach( category => {
                    let listItem = document.createElement('li');
                    listItem.classList.add('map__group__list-item');
                    listItem.innerHTML = `<span data-group="${category.slug}" class="group-toggle">${category.title}</span>`;
                    groupListEl.appendChild(listItem);
                } );

                groupEl.appendChild(groupListEl);
                mapContainerEl.appendChild(groupEl);

                groupEl.API = {
                    setActive: groupSetActive
                }

                function groupSetActive( group) {
                    let deactive = groupEl.querySelectorAll('.group-toggle:not([data-group="'+group+'"])');
                    let active = groupEl.querySelector(`[data-group="${group}"]`);
                    deactive.forEach( el => el.classList.remove('active') );
                    active.classList.add('active');
                }

                items.forEach( item => {
                    let listItemEl = document.createElement('li');
                    listItemEl.classList.add('map__location-list__item');
                    listItemEl.classList.add(item.category.toLowerCase());
                    listItemEl.dataset.id = item.id;
                    listItemEl.setAttribute('data-location', '');
                    listItemEl.innerHTML = `<div class="label">${item.title}</div>`;
                    listEl.appendChild(listItemEl);
                });
                mapLocationInnerEl.appendChild(listEl);
                mapLocationEl.appendChild(mapLocationInnerEl);

                Array.prototype.forEach.call( listEl.children, el => {
                    Object.assign( el.style, {
                        opacity: 1,
                        overflow: 'visible',
                        maxHeight: el.scrollHeight + 'px',
                    } );
                } );
            }
            
            /* Resize observer */
            new ResizeObserver( entries => {
                let listItems = Array.prototype.slice.call(listEl.querySelectorAll('[data-location]'));
                listItems.forEach( el => {
                    if (el.style.opacity === '0') return;
                    Object.assign( el.style, {
                        maxHeight: el.scrollHeight + 'px',
                    } );
                } );
            } ).observe(listEl);

            new ResizeObserver( entries => {
                mapContainerEl.classList.toggle( 'map--small', mapContainerEl.clientWidth <= 600 );
                mapContainerEl.classList.toggle( 'map--short', mapContainerEl.clientHeight <= 400 );
                if (mapContainerEl.clientWidth <= 600) {
                    mapInfoPanelEl.style.height = '';
                }
            } ).observe( mapContainerEl );

            let resizeTimeout;
            new ResizeObserver( entries => {
                mapContainerEl.classList.add('resizing');
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    mapContainerEl.classList.remove('resizing');
                }, 300);
            }).observe(mapContainerEl);
            /* End Resize observer */

            let currentGroup = 'all';
            mapContainerEl.addEventListener('click', ev => {
                let isGroupToggle = ev.target.closest('[data-group]');
                let isFilterToggle = ev.target.closest('[data-filter-toggle]');
                let isPanelInfo = ev.target.closest('[data-panel-info]');
                let isCloseButton = ev.target.closest('[data-close-map-panel]');

                if (isGroupToggle) {
                    let group = isGroupToggle.dataset.group;
                    let listItems = Array.prototype.slice.call(listEl.querySelectorAll('[data-location]'));

                    if (currentGroup === group) {
                        return;
                    }

                    currentGroup = group;
                    groupEl.API.setActive(group);

                    let o, speed = 200;
                    clearTimeout(o);
                    mapLocationInnerEl.style.overflow = 'hidden';
                    o = setTimeout(() => {
                        mapLocationInnerEl.style.overflow = '';
                    }, speed);
                    
                    if (group === 'all') {
                        listItems.forEach( el => {
                            Object.assign( el.style, {
                                opacity: 1,
                                overflow: 'visible',
                                maxHeight: el.scrollHeight + 'px',
                                paddingTop: '',
                                paddingBottom: '',
                            } );
                        } );
                    } else {
                        let a = listItems.filter( el => el.classList.contains(group) );
                        let b = listItems.filter( el => !el.classList.contains(group) );
                        a.filter( el => {
                            Object.assign( el.style, {
                                opacity: 1,
                                overflow: 'visible',
                                maxHeight: el.scrollHeight + 'px',
                                paddingTop: '',
                                paddingBottom: '',
                            } );
                        } );
                        b.filter( el => {
                            Object.assign( el.style, {
                                opacity: 0,
                                overflow: 'hidden',
                                maxHeight: 0 + 'px',
                                paddingTop: 0 + 'px',
                                paddingBottom: 0 + 'px',
                            } );
                        } );
                    }
                }

                if (isFilterToggle) {
                    userControlEl.API.show();
                }

                if (isPanelInfo && !isCloseButton) {
                    if (isSmall()) {
                        mapInfoExpand();
                    }
                }

                if (isCloseButton) {
                    mapInfoHide();
                }
            });

            /* Filter toggle button */
            if (['multiple', 'multiple_cat'].includes(type)) {
                userControlEl = document.createElement('div');
                userControlEl.classList.add('map__user-control');
                userControlEl.innerHTML = `
                    <div class="map__user-control__item">
                        <button class="filter-toggle" data-filter-toggle><span class="eicon-search-bold"></span></button>
                    </div>
                `;
                mapContainerEl.appendChild(userControlEl);

                userControlEl.API = {
                    show: filterShow,
                    hide: filterHide,
                    toggle: filterToggle,
                    isShow: filterIsShow,
                }

                function filterShow() {
                    mapContainerEl.classList.add('map--filter-show');
                }
    
                function filterHide() {
                    mapContainerEl.classList.remove('map--filter-show');
                }
    
                function filterToggle() {
                    mapContainerEl.classList.toggle('map--filter-show');
                }
    
                function filterIsShow() {
                    return mapContainerEl.classList.contains('map--filter-show');
                }
            }

            let filterHideTimeout;
            mapLocationEl.addEventListener('click', ev => {
                let isLocation = ev.target.closest('[data-location]');

                if (isLocation) {
                    let locationId = isLocation.dataset.id;
                    if (!locationId) return;

                    let offsetY = 0;
                    offsetY += settings.marker.height / 2;

                    let {latlng} = getLocationById( locationId );
                    map.panTo( getLatLngFromString(latlng) );

                    mapInfoUpdate( locationId ); 

                    if ( !mapInfoIsShow() ) {
                        mapInfoShow();
                    }

                    if (isSmall()) {
                        offsetY -= 184/2;
                        clearTimeout(filterHideTimeout);
                        filterHideTimeout = setTimeout(() => {
                            userControlEl.API.hide();
                        }, 1000);
                    }

                    map.panBy(0, offsetY * -1);
                }
            } );

            google.maps.event.addListenerOnce(map, 'idle', () => {
                if ( settings.center !== '' ) {
                    let latlng = getLatLngFromString(settings.center);
                    map.setCenter(latlng);
                }

                if ( settings.fitToBound === '1' ) {
                    map.fitBounds(bounds);
                }

                centerInfo.API.setLat( map.getCenter().lat().toFixed(5) );
                centerInfo.API.setLng( map.getCenter().lng().toFixed(5) );
            });

            map.addListener('center_changed', () => {
                centerInfo.API.setLat( map.getCenter().lat().toFixed(5) );
                centerInfo.API.setLng( map.getCenter().lng().toFixed(5) );
            });

            mapEl.addEventListener('MAP_INFO_UPDATE', ev => {
                let mapContainerEl = element.querySelector('.map');
                let locationId = ev.detail.id;
                mapContainerEl.dataset.active = locationId;

                setLocationActive( locationId );

                google.maps.event.addListenerOnce(map, 'idle', () => {
                    let marker = markers.find( el => el.content.dataset.id === locationId );
                    if (marker.content.classList.contains('map-marker--active')) return;
                    
                    marker.content.classList.add('map-marker--active');
                    marker.zIndex = 1;

                    markers.forEach( el => {
                        if (el.content.isEqualNode(marker.content)) return;
                        el.content.classList.remove('map-marker--active');
                        el.zIndex = null;
                    });
                });
            });
            
            mapEl.addEventListener('MAP_INFO_HIDE', ev => {
                let mapContainerEl = element.querySelector('.map');
                mapContainerEl.dataset.active = '';
                
                let marker = markers.find( el => el.content.classList.contains('map-marker--active') );
                if (marker) {
                    marker.content.classList.remove('map-marker--active');
                }

                let
                offsetX = 0,
                offsetY = 0;

                if (type === 'single') {
                    if (!isSmall()) {
                        offsetX -= (mapInfoPanelEl.clientWidth + 16) / 2;
                    } else {
                        offsetY -= 184/2;
                    }
                }

                if ( ['multiple', 'multiple_cat'].includes(type) ) {
                    if (isSmall()) {
                        offsetY -= 184/2;
                    }
                }

                map.panBy(offsetX, offsetY);

                if (userControlEl !== undefined) {
                    userControlEl.API.hide();
                }

                clearLocationActive();
            });

            /* Map center info */
            const centerInfo = document.createElement('div');
            centerInfo.classList.add('map__center-info');
            centerInfo.innerHTML = `
                <div>
                    <div>Center: </div>
                    <div><span class="latlng"><span data-lat></span>, <span data-lng></span></span> <button title="Copy" class="copy-button" data-copy><i class="eicon-copy"></i></button></div>
                </div>
            `;
            centerInfo.API = {
                setLat: (n) => centerInfo.querySelector('[data-lat]').textContent = n,
                setLng: (n) => centerInfo.querySelector('[data-lng]').textContent = n,
                getLat: () => parseFloat(centerInfo.querySelector('[data-lat]').textContent),
                getLng: () => parseFloat(centerInfo.querySelector('[data-lng]').textContent),
            };

            if (this.isEdit) {
                mapContainerEl.appendChild( centerInfo );
                centerInfo.addEventListener('click', (ev) => {
                    let isCopyButton = ev.target.closest('[data-copy]');
                    if (isCopyButton) {
                        let latlng = centerInfo.querySelector('.latlng').textContent;
                        navigator.clipboard.writeText( latlng.replace(/ /g, '') );
                        console.info('copied!');
                    }
                });
            }

            function getLocationById( id ) {
                if ( !id ) return;
                return settings.items.find( location => location.id === id );
            }

            function createMarker( lat, lng, title, content ) {
                let marker = new AdvancedMarkerElement({
                    position: {lat, lng},
                    map,
                    title,
                    content
                });

                return marker;
            }

            function getMarkerHTMLElement( marker, id ) {
                let output = document.createElement('div');
                output.classList.add('map-marker');
                if (id) {
                    output.dataset.id = id;
                }
                output.innerHTML = `<div class="map-marker__inner"><div class="map-marker__icon">${marker}</div></div>`;
                return output;
            }

            function getIconHTML( icon ) {
                let iconHTML;
                if ( icon.library.indexOf('fa') === 0 ) {
                    iconHTML = `<i class="${icon.value}"></i>`;
                }
                return iconHTML;
            }

            function getLatLngFromString( latlng ) {
                let latlngArr = latlng.split(',');
                return {
                    lat: parseFloat(latlngArr[0]),
                    lng: parseFloat(latlngArr[1])
                };
            }

            function mapInfoUpdate( id ) {
                /* If the current location is the same as the new location, return */
                if (getCurrentLocationId() === id) {
                    return;
                }

                let contentEl = mapInfoPanelEl.querySelector('.map__info-panel-inner');
                contentEl.innerHTML = mapInfoTemplateById( id );
                infoScrollBar.recalculate();
                mapEl.dispatchEvent(
                    new CustomEvent('MAP_INFO_UPDATE', {
                        detail: {id}
                    }
                ));
            }

            function mapInfoShow() {
                mapContainerEl.classList.add('map--info-show');
                mapInfoPanelEl.classList.add('show');
            }

            let expandEvent;
            
            function mapInfoExpand() {
                mapInfoPanelEl.classList.add('expand');
                expandEvent = document.addEventListener('click', ev => {
                    let isPanelInfo = ev.target.closest('[data-panel-info]');
                    if (!isPanelInfo) {
                        mapInfoCollapse();
                    }
                });
            }

            function mapInfoCollapse() {
                mapInfoPanelEl.classList.remove('expand');
                document.removeEventListener('click', expandEvent);
            }

            function mapInfoHide() {
                mapContainerEl.classList.remove('map--info-show');
                ['show', 'expand'].forEach( c => mapInfoPanelEl.classList.remove(c) );
                mapEl.dispatchEvent( new CustomEvent('MAP_INFO_HIDE') );
            }

            function mapInfoIsShow() {
                return mapInfoPanelEl.classList.contains('show');
            }

            function mapInfoToggle() {
                if ( mapInfoIsShow() ) {
                    mapInfoHide();
                } else {
                    mapInfoShow();
                }
            }

            mapInfoPanelEl.API = {
                show: mapInfoShow,
                hide: mapInfoHide,
                toggle: mapInfoToggle,
                isShow: mapInfoIsShow,
                update: mapInfoUpdate
            }

            function getCurrentLocationId() {
                return mapContainerEl.dataset.active;
            }

            function getLocationActive( id ) {
                if (!id) return;
                let item = mapLocationEl.querySelector( `[data-id="${id}"]` );
                return item;
            }

            function setLocationActive( id ) {
                if (!id) return;
                let item = getLocationActive( id );
                let items = mapLocationEl.querySelectorAll('.map__location-list__item');
                Array.prototype.forEach.call( items, el => {
                    if ( el.isEqualNode(item) ) {
                        el.classList.add('active');

                        let inCategoryList = el.closest('[data-category]');
                        if (inCategoryList) {
                            let locationList = inCategoryList.querySelector('.map__location-list');
                            locationList.API.show();
                        }
                    } else {
                        el.classList.remove('active');
                    }
                } );
            }

            function clearLocationActive() {
                let items = mapLocationEl.querySelectorAll('.map__location-list__item');
                Array.prototype.forEach.call( items, el => {
                    el.classList.remove('active');
                } );
            }

            function mapInfoTemplateById( id ) {
                let location = settings.items.find( location => location.id === id );

                let hasRating = location.rating && location.rating.value > 0;
                mapInfoPanelEl.classList.toggle('has-rating', hasRating);

                return `<div>
                    <div class="image">${location.image_html}</div>
                    <h3 class="heading">${location.title}</h3>
                    ${ location.rating ? `<div class="rating"><span class="rating__text">${ renderRating(location.rating) }</span></div>` : '' }
                    ${ location.content ? `<div class="content">${location.content}</div>` : '' }
                    <div class="cta">
                        ${ sprintf('<a class="cta-button" href="%2$s" target="%3$s">%1$s</a>',
                            sprintf( _x('View on Google Maps %s', 'widget-location-map', 'travelanium-elementor'), '<i class="eicon-editor-external-link"></i>' ),
                            `https://www.google.com/maps/search/?api=1&query=${location.title}`,
                            '_blank'
                        ) }
                    </div>
                    <button class="map__info-close-button" data-close-map-panel>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" width="1em" height="1em" fill="currentColor"><path d="M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.5 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z"/></svg>
                    </button>
                </div>`;
            }

            function renderRating( ratingObj ) {
                let {value, format, custom} = ratingObj;
                switch (format) {
                    case 'star': return renderRatingStar( value );
                    case 'custom': return custom.replace(/{{rating}}/g, value);
                }
            }

            function renderRatingStar( n ) {
                let output = '';
                for (let i = 0; i < n; i++) {
                    output += '<i class="eicon-star"></i>';
                }
                return output;
            }
        } );
    }

    generateRandomString( length ) {
        let l = length || 16;
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let randomString = '';
        
        for (let i = 0; i < l; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            randomString += characters.charAt(randomIndex);
        }
        
        return randomString;
    }
}

window.addEventListener('elementor/frontend/init', () => {
    let addHandler = function ($element) {
        window.elementorFrontend.elementsHandler.addHandler(TELocationMapWidget, {$element});
    }

    window.elementorFrontend.hooks.addAction('frontend/element_ready/location-map.default', addHandler);
} );